import React from "react";
import { MagnifyingGlassIcon, LinkIcon } from "@heroicons/react/24/outline";
import { useSearch } from "../util/SearchContext";

export default function SearchBarSmall() {
  const { searchQuery, setSearchQuery, handleSearch } = useSearch();

  const handleInput = (e) => setSearchQuery(e.target.value);
  const handleKeyDown = (e) => { if (e.key === "Enter") handleSearch(searchQuery); };

  return (
    <div className="w-full sm:w-96">
      <div className="flex items-center border border-gray-300 rounded-full bg-white shadow-md p-1 transition-all duration-300">
        <input
          type="text"
          value={searchQuery}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          placeholder="Search all recipes..."
          className="flex-1 bg-transparent outline-none px-3 text-gray-800 placeholder-gray-500 text-sm h-8"
        />
        <button onClick={() => handleSearch(searchQuery)} className="bg-green-600 text-white p-1.5 rounded-full hover:bg-green-700 transition duration-300">
          {searchQuery.startsWith("http") ? <LinkIcon className="w-4 h-4" /> : <MagnifyingGlassIcon className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );
}
